export const taggerKey = {
    GENERIC: 0,
    IHC: 1
}